module.exports = __webpack_public_path__ + "static/assets/e4cbc9e7f6da2934ba1c15e7668420c8.svg";